/**
 * Studio Home — Shopify Customer Privacy -> Google Consent Mode v2.
 * Copied from Heartland Sheds (validated 2026-08-28) on 2026-10-08. Replaces the older
 * Studio Home bridge, which set Consent Mode but did NOT expose window.__shedConsent or
 * push `privacy_api_ready` — the two things GTM's "CJS - Block Unconsented CA" variable
 * and "Privacy API Ready" trigger depend on.
 *
 * Must load synchronously in theme.liquid <head>, before GTM loads.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  var privacyApiRequested = false;
  var privacyApiAttempts = 0;
  var lastAppliedState = '';

  function googleConsentState(marketing, analytics, preferences) {
    return {
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied',
      analytics_storage: analytics ? 'granted' : 'denied',
      functionality_storage: preferences ? 'granted' : 'denied',
      personalization_storage: preferences ? 'granted' : 'denied',
      security_storage: 'granted'
    };
  }

  // Granted by default outside California.
  window.gtag('consent', 'default', googleConsentState(true, true, true));

  // California stays denied until Shopify reports an allowed state.
  window.gtag('consent', 'default', Object.assign(
    googleConsentState(false, false, false),
    { region: ['US-CA'], wait_for_update: 2000 }
  ));

  window.gtag('set', 'ads_data_redaction', true);
  window.gtag('set', 'url_passthrough', true);

  function applyConsent(marketing, analytics, preferences, saleOfData, region) {
    var normalized = {
      marketingAllowed: marketing === true,
      analyticsProcessingAllowed: analytics === true,
      preferencesProcessingAllowed: preferences === true,
      saleOfDataAllowed: saleOfData !== false,
      region: region || window.__shedConsentRegion || ''
    };
    var signature = [
      normalized.marketingAllowed,
      normalized.analyticsProcessingAllowed,
      normalized.preferencesProcessingAllowed,
      normalized.saleOfDataAllowed,
      normalized.region
    ].join('|');

    if (signature === lastAppliedState) return;
    lastAppliedState = signature;
    window.__shedConsent = normalized;

    window.gtag('consent', 'update', googleConsentState(
      normalized.marketingAllowed,
      normalized.analyticsProcessingAllowed,
      normalized.preferencesProcessingAllowed
    ));

    window.dataLayer.push({
      event: 'privacy_api_ready',
      shopify_consent: normalized
    });
  }

  // ─── Fast path: synchronous read of Shopify's stored consent cookie ───────
  // Applies a returning visitor's prior choice immediately, ahead of the async
  // round trip below. Deliberately conservative: if marketing+analytics both
  // read true, applyConsent allows immediately regardless of region. If the
  // choice is anything else or ambiguous, this defaults toward blocked, same
  // as a fresh visitor — the async path corrects it moments later either way.
  // Never guesses in a direction that could under-block a CA visitor.
  (function () {
    try {
      var match = document.cookie.match(/(?:^|;\s*)_tracking_consent=([^;]+)/);
      if (!match) return;
      var stored = JSON.parse(decodeURIComponent(match[1]));
      var con = stored && stored.con;
      if (!con) return;

      var marketing  = con.m === '1' || con.m === 'yes' || con.m === true;
      var analytics  = con.a === '1' || con.a === 'yes' || con.a === true;
      var functional = con.p === '1' || con.p === 'yes' || con.p === true;
      var saleOfData = con.s !== '0' && con.s !== 'no' && con.s !== false;

      applyConsent(marketing, analytics, functional, saleOfData, stored.region || '');
    } catch (e) {
      // Cookie unreadable or unexpected shape — fall through to async path.
    }
  })();

  // ─── Async path: Shopify Customer Privacy API (authoritative) ─────────────
  var features = [{ name: 'consent-tracking-api', version: '0.1' }];

  function syncFromPrivacyApi() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;

    window.__shedConsentRegion = privacy.getRegion ? privacy.getRegion() : '';

    applyConsent(
      privacy.marketingAllowed(),
      privacy.analyticsProcessingAllowed(),
      privacy.preferencesProcessingAllowed(),
      privacy.saleOfDataAllowed(),
      window.__shedConsentRegion
    );
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = (event && event.detail) || {};
    applyConsent(
      detail.marketingAllowed,
      detail.analyticsAllowed,
      detail.preferencesAllowed,
      detail.saleOfDataAllowed,
      window.__shedConsentRegion
    );
  });

  function requestPrivacyApi() {
    privacyApiAttempts += 1;

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      if (privacyApiAttempts < 200) window.setTimeout(requestPrivacyApi, 50);
      return;
    }
    if (privacyApiRequested) return;
    privacyApiRequested = true;

    window.Shopify.loadFeatures(features, function (error) {
      if (error) {
        console.error('Failed to load Shopify Customer Privacy API.', error);
        return;
      }
      syncFromPrivacyApi();
    });
  }

  requestPrivacyApi();
}());